import type { PdfProvider } from "./PdfProvider";
import type { TDocumentDefinitions } from "pdfmake/interfaces";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export class PdfMakeAdapter implements PdfProvider {
    open(doc: TDocumentDefinitions) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.createPdf(doc).open();
    }
}
